import { emailSchema } from "utils/validation/validationHelpers";
import { object } from 'yup';

const sendIntakeSchema = object().shape({
    email: emailSchema,
});

export default sendIntakeSchema;